import React, { useState } from 'react';
import { Trash } from '@phosphor-icons/react';
import classNames from 'classnames';

import { File } from '../../types';
import { getFileUrl, getFileImg, getThumbnail } from '../../utils';

import { Button, Spinner, Modal } from '../general';

interface Props {
  show: boolean;
  onHide: () => void;
  file: File | null;
  isVideo?: boolean;
  isPortrait?: boolean;
  handleDeletePhoto?: () => void;
}

const AssetPreviewModal: React.FC<Props> = (props) => {
  const { show, onHide, file, isVideo, isPortrait, handleDeletePhoto } = props;

  const [isDeleting, setIsDeleting] = useState(false);

  const time =
    file &&
    new Date(file?.created).toLocaleString('en-AU', {
      timeZone: 'Australia/Sydney',
    });

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title className="w-full whitespace-nowrap overflow-hidden text-ellipsis">
          {file?.name}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isVideo ? (
          <video
            className={classNames(
              'w-full max-h-[90vh] sm:max-h-[70vh] bg-black rounded-md object-contain',
              {
                'aspect-video': !isPortrait,
                'aspect-[9/16]': isPortrait,
              },
            )}
            src={file ? getFileUrl(file.elementId, file.name) : undefined}
            poster={file?.frameId ? getThumbnail(file.frameId) : undefined}
            controls
            autoPlay
          />
        ) : (
          <img
            src={getFileImg(file)}
            alt={file?.name}
            className="w-fit max-w-full h-fit max-h-[75vh] object-contain self-center rounded-md"
          />
        )}
      </Modal.Body>

      <Modal.Footer className="flex items-center justify-between">
        <div>Uploaded on {time}</div>

        {handleDeletePhoto && (
          <Button
            onClick={() => {
              setIsDeleting(true);
              handleDeletePhoto();
            }}
            variant="link"
          >
            {isDeleting ? (
              <Spinner size="sm" color="primary" />
            ) : (
              <Trash size="1.25rem" />
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default AssetPreviewModal;
